import { generateCsv, download } from 'export-to-csv';
import { Box } from '@mui/material';
import CsvConfig from './CsvConfig';

export default class RptExportLicenses {

  constructor() {
    if (this.constructor.instance) {
        return this.constructor.instance;
      }
      this.constructor.instance = this;
}

  // Get Visibility based on details (TBD!!!)
  getVisibility(extraCols) {
    if (extraCols) {
      return {ActivationPassword: true, ProductID:true, ProdOptionID:true, LicenseEnteredBy:true, LicenseLicenseeName:true, LicenseGroup:true, ResultCode:false, isTest:false, isActive:false, isSuccess:false } 
    }
    else {
      return { ActivationPassword: false, ProductID:false, ProdOptionID:false, LicenseEnteredBy:false, LicenseLicenseeName:false, LicenseGroup:false, ResultCode:false, isTest:false, isActive:false, isSuccess:false }
    }
  }

  // dataTableColumns - the definition of the columns
  dataTableColumns() {
  return(
  [
    {
      accessorKey: "LicenseEnteredDate", 
      header: "LicenseEnteredDate",
      filterVariant: 'date-range',
      accessorFn: (originalRow) => new Date(originalRow.LicenseEnteredDate),
      Cell: ({ cell }) => (cell.getValue() === '' ? '' : cell.getValue().toLocaleString('sv-SE')),
    },
    {
      accessorKey: "CompanyName",
      header: "CompanyName",
      filterFn: 'contains',
    },
    {
      accessorKey: "CustomerID", 
      header: "CustomerID",
      filterFn: 'contains',
      Cell: ({ cell }) => (<Box sx={{color:'blue'}}>{cell.getValue()}</Box>),      
      muiTableBodyCellProps: ({ cell, column, table }) => ({
        onDoubleClick: (event) => {
          console.info(event.target.innerText);
          window.open("https://license.netlibsecurity.com/solo/authors/CustomerDetails.aspx?CustomerID="+event.target.innerText, '_blank')
        },
      }),          
    },
    {
      accessorKey: "LicenseID", 
      header: "LicenseID",
      filterFn: 'contains',
      Cell: ({ cell }) => (<Box sx={{color:'blue'}}>{cell.getValue()}</Box>),          
      muiTableBodyCellProps: ({ cell, column, table }) => ({
        onDoubleClick: (event) => {
          console.info(event.target.innerText);
          window.open("https://license.netlibsecurity.com/solo/authors/orderdetail.asp?Action=View&LicenseID="+event.target.innerText, '_blank')
        },
      }),        
    },
    {
      accessorKey: "ProductName", 
      header: "ProductName",
      filterFn: 'contains',
    },
    {
      accessorKey: "OptionName", 
      header: "OptionName",
      filterFn: 'contains',
    },
    {
      accessorKey: "ActivationPassword", 
      header: "ActivationPassword",
      filterFn: 'contains',
    },
    {
      accessorKey: "Status", 
      header: "Status",
      filterFn: 'contains',
    },
    {
      accessorKey: "ProductID", 
      header: "ProductID",
      filterFn: 'contains',
    },
    {
        accessorKey: "ProdOptionID", 
        header: "ProdOptionID",
        filterFn: 'equals',
      },
    {
      accessorKey: "UnlocksLeft", 
      header: "Activations Left",
      filterFn: 'contains',
    },
    {
      accessorKey: "LicenseCounter", 
      header: "LicenseCounter",
      filterFn: 'contains',
    },
    {
      accessorKey: "ExpirationDate",
      header: "ExpirationDate",
      filterVariant: 'date-range',
      accessorFn: (originalRow) => new Date(originalRow.ExpirationDate),
      Cell: ({ cell }) => (cell.getValue() === '' ? '' : cell.getValue().toLocaleString('sv-SE')),
     },
     {
      accessorKey: "LicenseEnteredBy", 
      header: "LicenseEnteredBy",
      filterFn: 'contains',
    },
    {
      accessorKey: "LicenseLicenseeName", 
      header: "LicenseLicenseeName",
      filterFn: 'contains',
    },
    {
      accessorKey: "LicenseGroup", 
      header: "LicenseGroup",
      filterFn: 'contains',
    },             
    {
      header: 'Test',
      accessorFn: (originalRow) => (originalRow === undefined || originalRow.CompanyName === undefined ? 'false' : (originalRow.CompanyName[0].includes("TEST") ? 'true' : 'false')), //must be strings
      id: 'isTest',
      filterVariant: 'checkbox',
      Cell: ({ cell }) =>
        cell.getValue() === 'true' ? 'Test' : 'Prod',
      size: 170,
    } ,
    {
      header: 'Active', // Fake Column
      accessorFn: (originalRow) => "true",
      id: 'isActive',
      filterVariant: 'checkbox',
      Cell: ({ cell }) =>
        cell.getValue() === 'true' ? 'Active' : 'Active',
      size: 170,
    },
    {
      header: 'ResultCode', // Fake Column
      accessorFn: (originalRow) => "0",
      id: 'ResultCode',
      Cell: ({ cell }) =>
        cell.getValue() === 'true' ? '0' : '0',
      size: 170,
    },
    {
      header: 'Success', // Fake Column
      accessorFn: (originalRow) => "true",
      id: 'isSuccess',
      filterVariant: 'checkbox',
      Cell: ({ cell }) =>
        cell.getValue() === 'true' ? 'Success' : 'Success',
      size: 170,
    },           
  ]

)

  }

 // handleExportRows - sorted and selected data
 handleExportRows = (rows, extraCols) => {

  if (rows === undefined)
    return;

    const CSVConfig = new CsvConfig();
    const csvConfig = CSVConfig.makeCsvConfig();
    if (!extraCols) {
      var rowData;
      rowData = rows.map(
        function(row) {
          return { 
            "LicenseEnteredDate" : row.original.LicenseEnteredDate, 
            "CompanyName" : row.original.CompanyName[0], 
            "CustomerID" : row.original.CustomerID, 
            "LicenseID" : row.original.LicenseID, 
            "ProductName" : row.original.ProductName, 
            "OptionName" : row.original.OptionName,          
            "Status": row.original.Status, 
            "UnlocksLeft" : row.original.UnlocksLeft,             
            "LicenseCounter" : row.original.LicenseCounter,             
            "ExpirationDate" : row.original.ExpirationDate,                        
          }
        }
      )
    }
    else {
      rowData = rows.map(
        function(row) {
          return { 
            "LicenseEnteredDate" : row.original.LicenseEnteredDate[0], 
            "CompanyName" : row.original.CompanyName[0], 
            "CustomerID" : row.original.CustomerID[0], 
            "LicenseID" : row.original.LicenseID[0], 
            "ProductName" : row.original.ProductName[0], 
            "OptionName" : row.original.OptionName[0], 
            "ActivationPassword" : row.original.ActivationPassword[0],             
            "Status": row.original.Status[0], 
            "ProductID": row.original.ProductID[0], 
            "ProdOptionID": row.original.ProdOptionID[0],
            "UnlocksLeft" : row.original.UnlocksLeft[0],             
            "LicenseCounter" : row.original.LicenseCounter[0],             
            "ExpirationDate" : row.original.ExpirationDate[0],             
            "LicenseEnteredBy" : row.original.LicenseEnteredBy[0],             
            "LicenseLicenseeName" : row.original.LicenseLicenseeName[0],             
            "LicenseGroup" : row.original.LicenseGroup[0],             
          }
        }
      )
    }
    const csv = generateCsv(csvConfig)(rowData);
    download(csvConfig)(csv);
  };

  // handleExportData - all data
  handleExportData = (rows, extraCols) => {
    if (rows === undefined)
      return;

      if (rows === undefined)
      return;
  
      const CSVConfig = new CsvConfig();
      const csvConfig = CSVConfig.makeCsvConfig();
      if (!extraCols) {
        var rowData;
        rowData = rows.map(
          function(row) {
            return { 
              "LicenseEnteredDate" : row.LicenseEnteredDate[0], 
              "CompanyName" : row.CompanyName[0], 
              "CustomerID" : row.CustomerID[0], 
              "LicenseID" : row.LicenseID[0], 
              "ProductName" : row.ProductName[0], 
              "OptionName" : row.OptionName[0],           
              "Status": row.Status[0], 
              "UnlocksLeft" : row.UnlocksLeft[0],             
              "LicenseCounter" : row.LicenseCounter[0],             
              "ExpirationDate" : row.ExpirationDate[0],               
            }
          }
        )
      }
      else {
        rowData = rows.map(
          function(row) {
            return { 
              "LicenseEnteredDate" : row.LicenseEnteredDate[0], 
              "CompanyName" : row.CompanyName[0], 
              "CustomerID" : row.CustomerID[0], 
              "LicenseID" : row.LicenseID[0], 
              "ProductName" : row.ProductName[0], 
              "OptionName" : row.OptionName[0], 
              "ActivationPassword" : row.ActivationPassword[0],             
              "Status": row.Status[0], 
              "ProductID": row.ProductID[0], 
              "ProdOptionID": row.ProdOptionID[0],
              "UnlocksLeft" : row.UnlocksLeft[0],             
              "LicenseCounter" : row.LicenseCounter[0],             
              "ExpirationDate" : row.ExpirationDate[0],             
              "LicenseEnteredBy" : row.LicenseEnteredBy[0],             
              "LicenseLicenseeName" : row.LicenseLicenseeName[0],             
              "LicenseGroup" : row.LicenseGroup[0],               
            }
          }
        )
      }
      const csv = generateCsv(csvConfig)(rowData);
      download(csvConfig)(csv);
  };


}